<template>
    <div class="lini-view-container">
        <DxLoadPanel :visible="isPrinting" message="Se generează PDF-ul..." :show-overlay="true" :show-pane="true" />
        <div v-if="document" class="doc-header-card">
            <div class="doc-header-top">
                <div class="doc-header-main">
                    <i class="dx-icon dx-icon-doc doc-hdr-icon" />
                    <span class="doc-hdr-numar">#{{ document.Numar }}</span>
                    <span class="doc-hdr-categorie-badge">{{ document.Categorie }}</span>
                </div>
                <div class="doc-header-actions">
                    <DxButton icon="info" hint="Detalii Document" styling-mode="text" @click="$emit('toggle-details')" />
                    <DxButton icon="print" hint="Tipărire PDF" styling-mode="text" @click="onTiparirePDF" />
                    <DxButton icon="share" hint="Partajează" styling-mode="text" @click="shareClicked" />
                </div>
            </div>
            <div class="doc-meta-strip">
                <div class="doc-meta-item doc-meta-item--partener">
                    <i class="dx-icon dx-icon-group doc-meta-icon" />
                    <div class="doc-meta-content">
                        <span class="doc-meta-label">Partener</span>
                        <span class="doc-meta-value doc-meta-value--partener" :title="document.Partener">{{ document.Partener || '—' }}</span>
                    </div>
                </div>
                <div class="doc-meta-divider" />
                <div class="doc-meta-item">
                    <i class="dx-icon dx-icon-event doc-meta-icon" />
                    <div class="doc-meta-content">
                        <span class="doc-meta-label">Data</span>
                        <span class="doc-meta-value">{{ formatDate(document.Data) }}</span>
                    </div>
                </div>
                <div class="doc-meta-divider" />
                <div class="doc-meta-item">
                    <i class="dx-icon dx-icon-tags doc-meta-icon" />
                    <div class="doc-meta-content">
                        <span class="doc-meta-label">Tip</span>
                        <span class="doc-meta-value">{{ document.Tip }}</span>
                    </div>
                </div>
                <template v-if="document.Scadenta">
                    <div class="doc-meta-divider" />
                    <div class="doc-meta-item">
                        <i class="dx-icon dx-icon-clock doc-meta-icon" />
                        <div class="doc-meta-content">
                            <span class="doc-meta-label">Scadență</span>
                            <span class="doc-meta-value">{{ formatDate(document.Scadenta) }}</span>
                        </div>
                    </div>
                </template>
                <template v-if="document.Curs && document.Valuta && document.Valuta !== 'RON'">
                    <div class="doc-meta-divider" />
                    <div class="doc-meta-item">
                        <i class="dx-icon dx-icon-money doc-meta-icon" />
                        <div class="doc-meta-content">
                            <span class="doc-meta-label">Curs {{ document.Valuta }}</span>
                            <span class="doc-meta-value">{{ document.Curs?.toLocaleString('ro-RO', { minimumFractionDigits: 4 }) }}</span>
                        </div>
                    </div>
                </template>
                <div class="doc-meta-spacer" />
                <div class="doc-totals-box" v-if="document.Total || document.Valoare">
                    <div class="doc-totals-row" v-if="document.Valoare">
                        <span class="doc-totals-label">Fără TVA</span>
                        <span class="doc-totals-value-secondary">{{ document.Valoare.toLocaleString('ro-RO', { minimumFractionDigits: 2 }) }}&nbsp;{{ document.Valuta || 'RON' }}</span>
                    </div>
                    <div class="doc-totals-separator" v-if="document.Valoare && document.Total" />
                    <div class="doc-totals-row" v-if="document.Total">
                        <span class="doc-totals-label doc-totals-label--main">
                            <i class="dx-icon dx-icon-money" style="font-size:11px;vertical-align:middle;margin-right:3px" />
                            Total
                        </span>
                        <span class="doc-totals-value-main">{{ document.Total.toLocaleString('ro-RO', { minimumFractionDigits: 2 }) }}&nbsp;{{ document.Valuta || 'RON' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="document" class="grid-section">
            <component
                v-if="liniiComponent && areLinii"
                :is="liniiComponent"
                ref="liniiComponent"
                :document="document"
                @open-add-modal="onAddClick"
                @refresh-document="$emit('refresh-document', $event)"
                @has-linii-changed="onHasLiniiChanged"
            />
            <div v-if="!areLinii" class="no-lines-empty-state">
                <i class="dx-icon-info"></i>
                <p>Acest document nu are linii adăugate.</p>
                <DxButton icon="add" text="Adaugă prima linie" type="success" styling-mode="contained"
                    @click="onAddClick" />
            </div>
        </div>

        <div v-if="document === null" class="null-document-state">
            <i class="dx-icon-warning"></i>
            <p>Vă rugăm să selectați un document pentru a vedea detaliile.</p>
        </div>

        <DxPopup
            v-model:visible="isModalAddVisible"
            :show-title="false"
            :width="addPopupWidth"
            :height="addPopupHeight"
            :close-on-outside-click="false"
            :wrapper-attr="{ class: 'popup-linii' }"
            @hiding="onPopupHiding"
        >
            <div style="display:flex;flex-direction:column;height:100%;overflow:hidden;">
            <div style="flex-shrink:0;height:60px;padding:16px 24px;border-radius:4px 4px 0 0;background:linear-gradient(90deg,#ff2c21,#ff6a4a);display:flex;align-items:center;justify-content:space-between;">
                <div style="display:flex;align-items:center;gap:16px;">
                    <span class="dx-icon-add" style="font-size:24px;color:white;"></span>
                    <div style="display:flex;flex-direction:column;color:white;">
                        <span style="font-size:16px;font-weight:700;">Adăugare linie — {{ document?.Categorie }}</span>
                        <span style="font-size:12px;opacity:0.9;">Completează detaliile liniei noi</span>
                    </div>
                </div>
                <span style="background:rgba(255,255,255,0.2);color:white;padding:4px 12px;border-radius:12px;font-size:12px;font-weight:600;">Nou</span>
            </div>
            <div style="flex:1;overflow:hidden;">
            <template v-if="document?.Categorie === 'Contabilitate'">
                <div class="add-form-grid">
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Produs" label-mode="floating"
                            :data-source="dsProdus" value-expr="Id" :display-expr="produsDisplayExpr"
                            :search-expr="['Cod', 'CodIntern', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.ProdusId" @value-changed="onValueChangedProdus"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate" label-mode="floating"
                            :value="linieNoua.Cantitate" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            @value-changed="(e) => { linieNoua.Cantitate = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Unitate" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Procent TVA" label-mode="floating"
                            v-model:value="linieNoua.Tva" :min="0" :step="1"
                            :show-spin-buttons="true" :show-clear-button="true" format="## '%'"
                            @value-changed="(e) => { linieNoua.Tva = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Pret Unitar" label-mode="floating"
                            :value="linieNoua.PretUnitar" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }"
                            @value-changed="(e) => { linieNoua.PretUnitar = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Categorie Contabilă" label-mode="floating"
                            :data-source="dsCategorieContabila" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CategorieContabilaId"
                            @value-changed="(e) => linieNoua.CategorieContabilaId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Cont Debit" label-mode="floating"
                            :data-source="dsConturi" value-expr="Id" :display-expr="contDisplayExpr"
                            :search-expr="['Simbol', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.DebitId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Cont Credit" label-mode="floating"
                            :data-source="dsConturi" value-expr="Id" :display-expr="contDisplayExpr"
                            :search-expr="['Simbol', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.CreditId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Denumire Alternativă" label-mode="floating"
                            :value="linieNoua.Nume"
                            @value-changed="(e) => linieNoua.Nume = e.value" />
                    </div>
                </div>
            </template>
            <template v-else-if="document?.Categorie === 'Facturi furnizor'">
                <div class="add-form-grid">
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Produs" label-mode="floating"
                            :data-source="dsProdus" value-expr="Id" :display-expr="produsDisplayExpr"
                            :search-expr="['Cod', 'CodIntern', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.ProdusId" @value-changed="onValueChangedProdus"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate" label-mode="floating"
                            :value="linieNoua.Cantitate" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            @value-changed="(e) => { linieNoua.Cantitate = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Unitate" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="TVA Inclus %" label-mode="floating"
                            v-model:value="linieNoua.Tva" :min="0" :step="1"
                            :show-spin-buttons="true" :show-clear-button="true" format="## '%'"
                            @value-changed="(e) => { linieNoua.Tva = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Pret Unitar" label-mode="floating"
                            :value="linieNoua.PretUnitar" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }"
                            @value-changed="(e) => { linieNoua.PretUnitar = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Categorie Contabilă" label-mode="floating"
                            :data-source="dsCategorieContabila" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CategorieContabilaId"
                            @value-changed="(e) => linieNoua.CategorieContabilaId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Categorie TVA" label-mode="floating"
                            :value="linieNoua.CategTva"
                            @value-changed="(e) => linieNoua.CategTva = e.value" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Cod TVA (SAF-T)" label-mode="floating"
                            :value="linieNoua.SaftTaxCode"
                            @value-changed="(e) => linieNoua.SaftTaxCode = e.value" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Categorie TVA Motiv Scutire" label-mode="floating"
                            :value="linieNoua.CategTvaMotivScutire"
                            @value-changed="(e) => linieNoua.CategTvaMotivScutire = e.value" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Denumire Alternativă" label-mode="floating"
                            :value="linieNoua.Nume"
                            @value-changed="(e) => linieNoua.Nume = e.value" />
                    </div>
                </div>
            </template>
            <template v-else-if="document?.Categorie === 'Facturi client'">
                <div class="add-form-grid" style="overflow-y:auto;max-height:100%;">
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Produs" label-mode="floating"
                            :data-source="dsProdus" value-expr="Id" :display-expr="produsDisplayExpr"
                            :search-expr="['Cod', 'CodIntern', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.ProdusId" @value-changed="onValueChangedProdus"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate" label-mode="floating"
                            :value="linieNoua.Cantitate" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            @value-changed="(e) => { linieNoua.Cantitate = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Unitate" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Pret Unitar" label-mode="floating"
                            :value="linieNoua.PretUnitar" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }"
                            @value-changed="(e) => { linieNoua.PretUnitar = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="TVA %" label-mode="floating"
                            v-model:value="linieNoua.Tva" :min="0" :step="1"
                            :show-spin-buttons="true" :show-clear-button="true" format="## '%'"
                            @value-changed="(e) => { linieNoua.Tva = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Categorie Contabilă" label-mode="floating"
                            :data-source="dsCategorieContabila" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CategorieContabilaId"
                            @value-changed="(e) => linieNoua.CategorieContabilaId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Adaos/Discount %" label-mode="floating"
                            v-model:value="linieNoua.Adaos"
                            :step="1"
                            :show-spin-buttons="true" :show-clear-button="true" format="## '%'" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Adaos/Discount Unitar" label-mode="floating"
                            v-model:value="linieNoua.AdaosUnitar"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Valoare Adaos/Discount" label-mode="floating"
                            v-model:value="linieNoua.ValoareAdaos"
                            :show-spin-buttons="true" :show-clear-button="true" format="#,##0.00" />
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Categorie TVA" label-mode="floating"
                            :value="linieNoua.CategTva"
                            @value-changed="(e) => linieNoua.CategTva = e.value" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Cod TVA (SAF-T)" label-mode="floating"
                            :value="linieNoua.SaftTaxCode"
                            @value-changed="(e) => linieNoua.SaftTaxCode = e.value" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Categorie TVA Motiv Scutire" label-mode="floating"
                            :value="linieNoua.CategTvaMotivScutire"
                            @value-changed="(e) => linieNoua.CategTvaMotivScutire = e.value" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Denumire Alternativă" label-mode="floating"
                            :value="linieNoua.Nume"
                            @value-changed="(e) => linieNoua.Nume = e.value" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Explicatie" label-mode="floating"
                            :value="linieNoua.Custom"
                            @value-changed="(e) => linieNoua.Custom = e.value" />
                    </div>
                </div>
            </template>
            <template v-else-if="document?.Categorie === 'Mijloace fixe'">
                <div class="add-form-grid">
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Produs" label-mode="floating"
                            :data-source="dsProdus" value-expr="Id" :display-expr="produsDisplayExpr"
                            :search-expr="['Cod', 'CodIntern', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.ProdusId" @value-changed="onValueChangedProdus"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate" label-mode="floating"
                            :value="linieNoua.Cantitate" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            @value-changed="(e) => { linieNoua.Cantitate = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Unitate" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Pret Unitar" label-mode="floating"
                            :value="linieNoua.PretUnitar" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }"
                            @value-changed="(e) => { linieNoua.PretUnitar = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Adaos/Discount Unitar" label-mode="floating"
                            v-model:value="linieNoua.AdaosUnitar"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field">
                        <DxLookup label="Categorie Contabilă" label-mode="floating"
                            :data-source="dsCategorieContabila" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CategorieContabilaId"
                            @value-changed="(e) => linieNoua.CategorieContabilaId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Denumire Alternativă" label-mode="floating"
                            :value="linieNoua.Nume"
                            @value-changed="(e) => linieNoua.Nume = e.value" />
                    </div>
                </div>
            </template>
            <template v-else-if="document?.Categorie === 'Documente gestiune'">
                <div class="add-form-grid" style="overflow-y:auto;max-height:100%;">
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Produs" label-mode="floating"
                            :data-source="dsProdus" value-expr="Id" :display-expr="produsDisplayExpr"
                            :search-expr="['Cod', 'CodIntern', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.ProdusId" @value-changed="onValueChangedProdus"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate" label-mode="floating"
                            :value="linieNoua.Cantitate" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            @value-changed="(e) => { linieNoua.Cantitate = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Unitate" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Pret Unitar" label-mode="floating"
                            :value="linieNoua.PretUnitar" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }"
                            @value-changed="(e) => { linieNoua.PretUnitar = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Valoare" label-mode="floating"
                            v-model:value="linieNoua.Valoare"
                            :show-spin-buttons="true" :show-clear-button="true"
                            format="#,##0.00"
                            :disabled="true" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Adaos/Discount Unitar" label-mode="floating"
                            v-model:value="linieNoua.AdaosUnitar"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Scop Operational" label-mode="floating"
                            :data-source="dsCustomList" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CustomId"
                            @value-changed="(e) => linieNoua.CustomId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Categorie Contabilă" label-mode="floating"
                            :data-source="dsCategorieContabila" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CategorieContabilaId"
                            @value-changed="(e) => linieNoua.CategorieContabilaId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Garantie Luni" label-mode="floating"
                            v-model:value="linieNoua.GarantieLuni"
                            :min="0"
                            :show-spin-buttons="true" :show-clear-button="true" />
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Cod NC8" label-mode="floating"
                            :value="linieNoua.CodNc8"
                            @value-changed="(e) => linieNoua.CodNc8 = e.value" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Masa Net" label-mode="floating"
                            v-model:value="linieNoua.MasaNet"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Masa Brut" label-mode="floating"
                            v-model:value="linieNoua.MasaBrut"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Denumire Alternativă" label-mode="floating"
                            :value="linieNoua.Nume"
                            @value-changed="(e) => linieNoua.Nume = e.value" />
                    </div>
                </div>
            </template>
            <template v-else-if="document?.Categorie === 'Personal - Salarizare'">
                <div class="add-form-grid" style="overflow-y:auto;max-height:100%;">
                    <div class="add-form-field add-form-field--full" style="overflow:hidden;">
                        <DxLookup label="Produs" label-mode="floating"
                            :data-source="dsProdus" value-expr="Id" :display-expr="produsDisplayExpr"
                            :search-expr="['Cod', 'CodIntern', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.ProdusId" @value-changed="onValueChangedProdus"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate" label-mode="floating"
                            :value="linieNoua.Cantitate" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            @value-changed="(e) => { linieNoua.Cantitate = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Unitate" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Pret Unitar" label-mode="floating"
                            :value="linieNoua.PretUnitar" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }"
                            @value-changed="(e) => { linieNoua.PretUnitar = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Valoare" label-mode="floating"
                            v-model:value="linieNoua.Valoare"
                            :show-spin-buttons="true" :show-clear-button="true"
                            format="#,##0.00"
                            :disabled="true" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Adaos/Discount Unitar" label-mode="floating"
                            v-model:value="linieNoua.AdaosUnitar"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Total" label-mode="floating"
                            v-model:value="linieNoua.Total"
                            :show-spin-buttons="true" :show-clear-button="true"
                            format="#,##0.00"
                            :disabled="true" />
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Categorie Contabilă" label-mode="floating"
                            :data-source="dsCategorieContabila" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CategorieContabilaId"
                            @value-changed="(e) => linieNoua.CategorieContabilaId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxDropDownBox
                            ref="personalDepartamentBox"
                            label="Departament"
                            label-mode="floating"
                            v-model:value="linieNoua.StructIdEditabil"
                            :data-source="structuriIdEditabileItems"
                            value-expr="Id"
                            :display-expr="departamentDisplayExpr"
                            :show-clear-button="true"
                        >
                            <template #content>
                                <DxTreeView
                                    :items="structuriIdEditabileTree"
                                    key-expr="Id"
                                    display-expr="Nume"
                                    selection-mode="single"
                                    :select-by-click="true"
                                    @item-click="onPersonalDepartamentSelect"
                                />
                            </template>
                        </DxDropDownBox>
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Denumire Alternativă" label-mode="floating"
                            :value="linieNoua.Nume"
                            @value-changed="(e) => linieNoua.Nume = e.value" />
                    </div>
                </div>
            </template>
            <template v-else-if="document?.Categorie === 'Solduri Initiale'">
                <div class="add-form-grid" style="overflow-y:auto;max-height:100%;">
                    <div class="add-form-field add-form-field--full" style="overflow:hidden;">
                        <DxLookup label="Produs" label-mode="floating"
                            :data-source="dsProdus" value-expr="Id" :display-expr="produsDisplayExpr"
                            :search-expr="['Cod', 'CodIntern', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.ProdusId" @value-changed="onValueChangedProdus"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate" label-mode="floating"
                            :value="linieNoua.Cantitate" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            @value-changed="(e) => { linieNoua.Cantitate = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Unitate" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Pret Unitar" label-mode="floating"
                            :value="linieNoua.PretUnitar" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }"
                            @value-changed="(e) => { linieNoua.PretUnitar = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Valoare" label-mode="floating"
                            v-model:value="linieNoua.Valoare" format="#,##0.00" :disabled="true" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Adaos/Discount Unitar" label-mode="floating"
                            v-model:value="linieNoua.AdaosUnitar"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Total" label-mode="floating"
                            v-model:value="linieNoua.Total" format="#,##0.00" :disabled="true" />
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Loc Depozitare" label-mode="floating"
                            v-model:value="linieNoua.LocDepozitare" />
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Categorie Contabila" label-mode="floating"
                            :data-source="dsCategorieContabila" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CategorieContabilaId"
                            @value-changed="(e) => linieNoua.CategorieContabilaId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="UM FA" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateAmbalajId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate pentru 1 FA" label-mode="floating"
                            v-model:value="linieNoua.CantitatePt1Fa"
                            :show-spin-buttons="true" :show-clear-button="true" format="#,##0.00" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate FA" label-mode="floating"
                            v-model:value="linieNoua.CantitateFa"
                            :show-spin-buttons="true" :show-clear-button="true" format="#,##0.00" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Etichete" label-mode="floating"
                            :value="linieNoua.CantitateFa"
                            format="#,##0.00" :disabled="true" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Taxa Unitara" label-mode="floating"
                            v-model:value="linieNoua.TaxaUnitara"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Lot Furnizor" label-mode="floating"
                            v-model:value="linieNoua.CodLotFurnizor" />
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Lot Intern" label-mode="floating"
                            v-model:value="linieNoua.CodLotIntern" />
                    </div>
                    <div class="add-form-field" style="grid-column: 2">
                        <DxDateBox label="Data Expirarii" label-mode="floating"
                            v-model:value="linieNoua.DataExp"
                            display-format="dd.MM.yyyy" :show-clear-button="true" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Denumire Alternativa" label-mode="floating"
                            :value="linieNoua.Nume"
                            @value-changed="(e) => linieNoua.Nume = e.value" />
                    </div>
                </div>
            </template>
            <template v-else-if="document?.Categorie === 'Documente productie'">
                <div class="add-form-grid" style="overflow-y:auto;max-height:100%;">
                    <div class="add-form-field add-form-field--full" style="overflow:hidden;">
                        <DxLookup label="Produs" label-mode="floating"
                            :data-source="dsProdus" value-expr="Id" :display-expr="produsDisplayExpr"
                            :search-expr="['Cod', 'CodIntern', 'Nume']"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.ProdusId" @value-changed="onValueChangedProdus"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate" label-mode="floating"
                            :value="linieNoua.Cantitate" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            @value-changed="(e) => { linieNoua.Cantitate = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Unitate" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Pret Unitar" label-mode="floating"
                            :value="linieNoua.PretUnitar" :min="0"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }"
                            @value-changed="(e) => { linieNoua.PretUnitar = e.value; calculateTotalsLinie(); }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Valoare" label-mode="floating"
                            v-model:value="linieNoua.Valoare" format="#,##0.00" :disabled="true" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Adaos/Discount Unitar" label-mode="floating"
                            v-model:value="linieNoua.AdaosUnitar"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Total" label-mode="floating"
                            v-model:value="linieNoua.Total" format="#,##0.00" :disabled="true" />
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Loc Depozitare" label-mode="floating"
                            v-model:value="linieNoua.LocDepozitare" />
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="Categorie Contabila" label-mode="floating"
                            :data-source="dsCategorieContabila" value-expr="Id" display-expr="Nume"
                            :show-clear-button="true" :search-enabled="true"
                            :value="linieNoua.CategorieContabilaId"
                            @value-changed="(e) => linieNoua.CategorieContabilaId = e.value"
                            :drop-down-options="{ width: 'auto' }">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field" style="overflow:hidden;">
                        <DxLookup label="UM FA" label-mode="floating"
                            :data-source="dsUnitate" value-expr="Id" display-expr="Simbol"
                            :show-clear-button="true" :search-enabled="true"
                            v-model:value="linieNoua.UnitateAmbalajId">
                            <DxDropDownOptions :show-title="false" />
                        </DxLookup>
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate pentru 1 FA" label-mode="floating"
                            v-model:value="linieNoua.CantitatePt1Fa"
                            :show-spin-buttons="true" :show-clear-button="true" format="#,##0.00" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Cantitate FA" label-mode="floating"
                            v-model:value="linieNoua.CantitateFa"
                            :show-spin-buttons="true" :show-clear-button="true" format="#,##0.00" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Etichete" label-mode="floating"
                            :value="linieNoua.CantitateFa"
                            format="#,##0.00" :disabled="true" />
                    </div>
                    <div class="add-form-field">
                        <DxNumberBox label="Taxa Unitara" label-mode="floating"
                            v-model:value="linieNoua.TaxaUnitara"
                            :show-spin-buttons="true" :show-clear-button="true"
                            :format="{ type: 'fixedPoint', precision: 4 }" />
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Lot Furnizor" label-mode="floating"
                            v-model:value="linieNoua.CodLotFurnizor" />
                    </div>
                    <div class="add-form-field">
                        <DxTextBox label="Lot Intern" label-mode="floating"
                            v-model:value="linieNoua.CodLotIntern" />
                    </div>
                    <div class="add-form-field" style="grid-column: 2">
                        <DxDateBox label="Data Expirarii" label-mode="floating"
                            v-model:value="linieNoua.DataExp"
                            display-format="dd.MM.yyyy" :show-clear-button="true" />
                    </div>
                    <div class="add-form-field add-form-field--full">
                        <DxTextBox label="Denumire Alternativa" label-mode="floating"
                            :value="linieNoua.Nume"
                            @value-changed="(e) => linieNoua.Nume = e.value" />
                    </div>
                </div>
            </template>
            </div>
            <div class="form-footer-linie" style="flex-shrink:0;">
                <div class="footer-right-linie">
                    <DxButton text="Salvează" type="success" width="120" height="32"
                        styling-mode="outlined" @click="onSaveAdd" />
                    <DxButton text="Închide" type="danger" width="120" height="32"
                        styling-mode="outlined" @click="onCloseAdd" />
                </div>
            </div>
            </div>
        </DxPopup>

        <button
            v-if="document && !sidebarOpen"
            class="fab-edit-document"
            title="Editează document"
            @click="$emit('open-edit-document')"
        >
            <i class="dx-icon-edit"></i>
        </button>

    </div>
</template>
<script lang="ts">
import { locale, loadMessages } from 'devextreme/localization';
import {
    DxToolbar,
    DxToolbarItem,
    DxColumn,
    DxColumnChooser,
    DxDataGrid,
    DxEditing,
    DxExport,
    DxFilterRow,
    DxGrouping,
    DxGroupPanel,
    DxHeaderFilter,
    DxLoadPanel,
    DxPager,
    DxPaging,
    DxRemoteOperations,
    DxScrolling,
    DxSearchPanel,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxTexts,
    DxItem,
    DxForm as DxFormEdit,
} from 'devextreme-vue/data-grid';
import DxPopup from 'devextreme-vue/popup'
import DxDateBox from 'devextreme-vue/date-box';
import { DxButton } from 'devextreme-vue/button';
import { DxCheckBox, DxScrollView } from 'devextreme-vue';
import ODataStore from 'devextreme/data/odata/store';
import DataSource from "devextreme/data/data_source";
import AppSetting from '@/settings/appSettings';
import { DxLookup, DxDropDownOptions } from 'devextreme-vue/lookup';
import { DxForm, DxSimpleItem, DxGroupItem, DxLabel, DxEmptyItem } from "devextreme-vue/form"
import DxTextArea from 'devextreme-vue/text-area'
import DxTextBox from 'devextreme-vue/text-box';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import { readonly, version } from 'vue';
import { DxNumberBox } from "devextreme-vue/number-box"
import notify from 'devextreme/ui/notify'
import DocumenteTipuriDataService from '@/services/Documente/DOC_Tipuri'
import { defineComponent, ref } from 'vue';
import DOC_Linii from '@/services/Documente/DOC_Linii';
import DOC_Documente from '@/services/Documente/DOC_Documente';
import http from '@/settings/apiSettings';
import { LINII_COMPONENTS_MAP } from './linii-tabele/liniiComponentsMap';
export default defineComponent({
    name: 'LiniView',
    components: {
        DxButton,
        DxToolbar,
        DxToolbarItem,
        DxScrollView,
        DxColumn,
        DxColumnChooser,
        DxDataGrid,
        DxEditing,
        DxExport,
        DxFilterRow,
        DxGrouping,
        DxGroupPanel,
        DxHeaderFilter,
        DxLoadPanel,
        DxLookup,
        DxPager,
        DxPaging,
        DxRemoteOperations,
        DxScrolling,
        DxSearchPanel,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxTexts,
        DxForm,
        DxSimpleItem,
        DxTextArea,
        DxGroupItem,
        DxCheckBox,
        DxLabel,
        DxTextBox,
        DxEmptyItem,
        DxDropDownOptions,
        DxDateBox,
        DxItem,
        DxNumberBox,
        DxPopup,
        DxFormEdit,
        DxDropDownBox,
        DxTreeView,
        ...LINII_COMPONENTS_MAP
    },
    props: {
        document: Object,
        sidebarOpen: { type: Boolean, default: false },
    },
    computed: {
        successButtonOptions(): any {
            return {
                type: 'success',
                stylingMode: 'outlined',
                text: 'Salvează',
                onClick: () => {
                    this.$refs.dataGrid?.instance?.saveEditData();
                },
            };
        },
        dangerButtonOptions(): any {
            return {
                type: 'danger',
                stylingMode: 'outlined',
                text: 'Închide',
                onClick: () => {
                    this.$refs.dataGrid?.instance?.cancelEditData();
                },
            };
        },
        customTitleTemplate() {
            return `
          <div class="popup-header" style="width: 800px; height: 60px; margin: -5px -20px 0 -20px; padding: 16px 24px; background: linear-gradient(90deg, #ff2c21, #ff6a4a); display: flex; align-items: center; gap: 16px;">
             <span class="dx-icon-edit" style="font-size: 24px; width: 30px; height: 40px; display: flex; align-items: center; justify-content: center; border-radius: 8px; color: white;"></span>
             <div style="display: flex; flex-direction: column; color: white;">
                <span style="font-size: 16px; font-weight: 700;">Editare Linie existentă</span>
                <span style="font-size: 12px; opacity: 0.9;">Modifică detaliile liniei selectate</span>
             </div>
          </div>
        `;
        },
        liniiComponent() {
            if (!this.document.Categorie) return null
            return LINII_COMPONENTS_MAP[this.document.Categorie] ?? null
        },
        addPopupHeight(): number {
            if (this.document?.Categorie === 'Facturi furnizor') return 500;
            if (this.document?.Categorie === 'Facturi client') return 620;
            if (this.document?.Categorie === 'Mijloace fixe') return 370;
            if (this.document?.Categorie === 'Documente gestiune') return 550;
            if (this.document?.Categorie === 'Personal - Salarizare') return 500;
            if (this.document?.Categorie === 'Solduri Initiale') return 660;
            if (this.document?.Categorie === 'Documente productie') return 660;
            return 500;
        },
        addPopupWidth(): number {
            if (this.document?.Categorie === 'Solduri Initiale') return 740;
            if (this.document?.Categorie === 'Documente productie') return 740;
            return 700;
        },
        // editButtonOptions(): any {
        //     return {
        //         icon: this.isReadonly ? "edit" : "check",
        //         text: this.isReadonly ? "Permite modificarea pe linii" : "Finalizează",
        //         type: this.isReadonly ? "default" : "success",
        //         stylingMode: "outlined",
        //         onClick: () => this.updateReadOnly()
        //     };
        // },
    },
    data() {
        return {
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            dsLinii: {} as ODataStore,
            dsProduse: {} as ODataStore,
            editingOriginalRow: null as any,
            isStornatRetur: false,
            isReadonly: true,
            isDisabled: true,
            deletePopupVisible: false,
            partenerNou: {
                ID: null,
                Nume: this.document?.Partener,
                Cod: this.document?.PartenerCod,
                CUI: this.document?.PartenerCUI,
                GrupPartener: this.document?.GrupPartener
            },
            categorieDocument: null,
            tipDocument: null,

            dsCategorieDocumente: null,
            dsTipDocumente: null,
            dsAgent: null,
            dsZone: null,
            dsNumereContracte: null,
            dsPartener: null,
            dsGrupePartener: null,
            dsComenzi: null,
            dsProiecte: null,
            dsStructuriIdEditabile: null,
            structuriIdEditabileItems: [] as any[],
            structuriIdEditabileTree: [] as any[],
            dsGestiune: null,
            dsValute: null,
            dsProdus: null,
            dsUnitate: null,
            dsCategorieContabila: null,
            dsCustomList: null,
            areLinii: false,
            isPrinting: false,
            isModalAddVisible: false,
            dsConturi: null,
            linieNoua: {
                DocumentId: this.document?.Id,
                ProdusId: null,
                UnitateId: null,
                Cantitate: null,
                Tva: this.document?.Tva ?? 0,
                PretUnitar: 0,
                Valoare: null,
                ValoareTva: null,
                Total: 0,
                Tvaunitar: null,
                ValoarePret: null,
                ValoareAdaos: 0,
                AdaosUnitar: null,
                Adaos: null,
                Brut: null,
                PretCuAdaos: null,
                ValoareCuAdaos: null,
                PretTotal: 0,
                CategorieContabilaId: null,
                DebitId: null,
                CreditId: null,
                Nume: null,
                CategTva: null,
                SaftTaxCode: null,
                CategTvaMotivScutire: null,
                Custom: null,
                CustomId: null,
                GarantieLuni: null,
                CodNc8: null,
                MasaNet: null,
                MasaBrut: null,
                StructIdEditabil: null,
                UnitateAmbalajId: null,
                CantitateFa: null,
                CantitatePt1Fa: null,
                CodLotFurnizor: null,
                DataExp: null,
                CodLotIntern: null,
                LocDepozitare: null,
                TaxaUnitara: null,
            } as any
        }
    },
    methods: {
        onHasLiniiChanged(hasLinii) {
            this.areLinii = hasLinii;
        },
        onAddClick() {
            this.isModalAddVisible = true;
        },
        onEditingStartLinie(e: any) {
            this.editingOriginalRow = JSON.parse(JSON.stringify(e.data ?? {}));
        },
        onGridSaved() {
            this.$emit('refresh-document', this.document.Id);
        },
        setDeleteConfirmationMessage() {
            const grid = this.$refs.dataGrid?.instance;
            if (grid) {
                // Folosește string pentru a accesa adânc în obiect fără a-l suprascrie
                grid.option('editing.texts.confirmDeleteMessage', this.deleteConfirmationMessage);
                grid.option('editing.texts.confirmDeleteTitle', "Confirmare Ștergere");
            }
        },
        onPopupHiding() {
            this.isModalAddVisible = false;
            this.resetLinieNoua();
        },
        onCloseAdd() {
            this.isModalAddVisible = false;
            this.resetLinieNoua();
        },
        resetLinieNoua() {
            Object.assign(this.linieNoua, {
                DocumentId: this.document?.Id,
                ProdusId: null,
                UnitateId: null,
                Cantitate: null,
                Tva: this.document?.Tva ?? 0,
                PretUnitar: 0,
                Valoare: null,
                ValoareTva: null,
                Total: 0,
                Tvaunitar: null,
                ValoarePret: null,
                ValoareAdaos: 0,
                AdaosUnitar: null,
                Adaos: null,
                Brut: null,
                PretCuAdaos: null,
                ValoareCuAdaos: null,
                PretTotal: 0,
                CategorieContabilaId: null,
                DebitId: null,
                CreditId: null,
                Nume: null,
                CategTva: null,
                SaftTaxCode: null,
                CategTvaMotivScutire: null,
                Custom: null,
                CustomId: null,
                GarantieLuni: null,
                CodNc8: null,
                MasaNet: null,
                MasaBrut: null,
                StructIdEditabil: null,
                UnitateAmbalajId: null,
                CantitateFa: null,
                CantitatePt1Fa: null,
                CodLotFurnizor: null,
                DataExp: null,
                CodLotIntern: null,
                LocDepozitare: null,
                TaxaUnitara: null,
            });
        },
        contDisplayExpr(item: any) {
            if (!item) return '';
            return `${item.Simbol || ''} — ${item.Nume || ''}`;
        },
        onValueChangedProdus(e: any) {
            if (e.value != null) {
                this.linieNoua.ProdusId = e.value;
                this.dsProdus.store().byKey(e.value).then((produs: any) => {
                    this.linieNoua.CategorieContabilaId = produs?.CategorieContabilaId ?? null;
                    this.linieNoua.UnitateId = produs?.UnitateId ?? null;
                });
            } else {
                this.linieNoua.ProdusId = null;
                this.linieNoua.CategorieContabilaId = null;
                this.linieNoua.UnitateId = null;
            }
        },
        calculateTotalsLinie() {
            if (this.linieNoua.PretUnitar == null || this.linieNoua.Cantitate == null) return;
            this.linieNoua.Valoare = this.linieNoua.PretUnitar * this.linieNoua.Cantitate;
            this.linieNoua.ValoareCuAdaos = this.linieNoua.Valoare;
            this.linieNoua.PretCuAdaos = this.linieNoua.PretUnitar;

            DocumenteTipuriDataService.getByKey(this.document.TipId).then((tip: any) => {
                const tipData = tip.data;
                if (tipData.AreTva) {
                    if (tipData.Tvaaplicat) {
                        this.linieNoua.Tvaunitar = this.linieNoua.PretCuAdaos * ((this.linieNoua.Tva ?? 0) / 100);
                        this.linieNoua.PretTotal = this.linieNoua.PretCuAdaos + this.linieNoua.Tvaunitar;
                        this.linieNoua.ValoareTva = this.linieNoua.ValoareCuAdaos * ((this.linieNoua.Tva ?? 0) / 100);
                        this.linieNoua.Total = this.linieNoua.ValoareCuAdaos + this.linieNoua.ValoareTva;
                    } else {
                        this.linieNoua.Total = this.linieNoua.ValoareCuAdaos;
                        this.linieNoua.ValoareCuAdaos = this.linieNoua.Total / (1 + (this.linieNoua.Tva ?? 0) / 100);
                        this.linieNoua.ValoareTva = this.linieNoua.Total - this.linieNoua.ValoareCuAdaos;
                        this.linieNoua.Tvaunitar = this.linieNoua.Cantitate === 0 ? 0 : this.linieNoua.ValoareTva / this.linieNoua.Cantitate;
                        this.linieNoua.PretTotal = this.linieNoua.PretCuAdaos;
                    }
                } else {
                    this.linieNoua.Tva = 0;
                    this.linieNoua.Tvaunitar = 0;
                    this.linieNoua.PretTotal = this.linieNoua.PretCuAdaos;
                    this.linieNoua.ValoareTva = 0;
                    this.linieNoua.Total = this.linieNoua.ValoareCuAdaos;
                }
            });
        },
        async onSaveAdd() {
            if (!this.linieNoua.ProdusId || !this.linieNoua.Cantitate || this.linieNoua.Cantitate <= 0) {
                notify('Selectează produsul și cantitatea.', 'error', 3000);
                return;
            }

            const payload: any = {};
            if (this.document?.Categorie === 'Contabilitate') {
                Object.assign(payload, {
                    ProdusId: this.linieNoua.ProdusId,
                    UnitateId: this.linieNoua.UnitateId,
                    Cantitate: this.linieNoua.Cantitate,
                    TvaLinie: this.linieNoua.Tva,
                    PretUnitar: this.linieNoua.PretUnitar,
                    CategorieContabilaId: this.linieNoua.CategorieContabilaId,
                    DebitId: this.linieNoua.DebitId,
                    CreditId: this.linieNoua.CreditId,
                    ProdusNume: this.linieNoua.Nume,
                });
            } else if (this.document?.Categorie === 'Facturi furnizor') {
                Object.assign(payload, {
                    ProdusId: this.linieNoua.ProdusId,
                    UnitateId: this.linieNoua.UnitateId,
                    Cantitate: this.linieNoua.Cantitate,
                    TvaLinie: this.linieNoua.Tva,
                    PretUnitar: this.linieNoua.PretUnitar,
                    CategorieContabilaId: this.linieNoua.CategorieContabilaId,
                    CategTva: this.linieNoua.CategTva,
                    SaftTaxCode: this.linieNoua.SaftTaxCode,
                    CategTvaMotivScutire: this.linieNoua.CategTvaMotivScutire,
                    ProdusNume: this.linieNoua.Nume,
                });
            } else if (this.document?.Categorie === 'Facturi client') {
                Object.assign(payload, {
                    ProdusId: this.linieNoua.ProdusId,
                    UnitateId: this.linieNoua.UnitateId,
                    Cantitate: this.linieNoua.Cantitate,
                    TvaLinie: this.linieNoua.Tva,
                    PretUnitar: this.linieNoua.PretUnitar,
                    AdaosLinie: this.linieNoua.Adaos,
                    AdaosUnitarLinie: this.linieNoua.AdaosUnitar,
                    ValoareAdaosLinie: this.linieNoua.ValoareAdaos,
                    CategorieContabilaId: this.linieNoua.CategorieContabilaId,
                    CategTva: this.linieNoua.CategTva,
                    SaftTaxCode: this.linieNoua.SaftTaxCode,
                    CategTvaMotivScutire: this.linieNoua.CategTvaMotivScutire,
                    ProdusNume: this.linieNoua.Nume,
                    Custom: this.linieNoua.Custom,
                });
            } else if (this.document?.Categorie === 'Mijloace fixe') {
                Object.assign(payload, {
                    ProdusId: this.linieNoua.ProdusId,
                    UnitateId: this.linieNoua.UnitateId,
                    Cantitate: this.linieNoua.Cantitate,
                    PretUnitar: this.linieNoua.PretUnitar,
                    AdaosUnitarLinie: this.linieNoua.AdaosUnitar,
                    CategorieContabilaId: this.linieNoua.CategorieContabilaId,
                    ProdusNume: this.linieNoua.Nume,
                });
            } else if (this.document?.Categorie === 'Documente gestiune') {
                Object.assign(payload, {
                    ProdusId: this.linieNoua.ProdusId,
                    UnitateId: this.linieNoua.UnitateId,
                    Cantitate: this.linieNoua.Cantitate,
                    PretUnitar: this.linieNoua.PretUnitar,
                    ValoareLinie: this.linieNoua.Valoare,
                    AdaosUnitarLinie: this.linieNoua.AdaosUnitar ?? 0,
                    CustomId: this.linieNoua.CustomId,
                    CategorieContabilaId: this.linieNoua.CategorieContabilaId,
                    GarantieLuni: this.linieNoua.GarantieLuni,
                    ProdusNume: this.linieNoua.Nume,
                    CodNc8: this.linieNoua.CodNc8,
                    MasaNet: this.linieNoua.MasaNet,
                    MasaBrut: this.linieNoua.MasaBrut,
                });
            } else if (this.document?.Categorie === 'Personal - Salarizare') {
                Object.assign(payload, {
                    ProdusId: this.linieNoua.ProdusId,
                    UnitateId: this.linieNoua.UnitateId,
                    Cantitate: this.linieNoua.Cantitate,
                    PretUnitar: this.linieNoua.PretUnitar,
                    ValoareLinie: this.linieNoua.Valoare,
                    AdaosUnitarLinie: this.linieNoua.AdaosUnitar ?? 0,
                    CategorieContabilaId: this.linieNoua.CategorieContabilaId,
                    StructIdEditabil: this.linieNoua.StructIdEditabil,
                    ProdusNume: this.linieNoua.Nume,
                });
            } else if (this.document?.Categorie === 'Solduri Initiale') {
                Object.assign(payload, {
                    ProdusId: this.linieNoua.ProdusId,
                    UnitateId: this.linieNoua.UnitateId,
                    UnitateAmbalajId: this.linieNoua.UnitateAmbalajId,
                    Cantitate: this.linieNoua.Cantitate,
                    PretUnitar: this.linieNoua.PretUnitar,
                    ValoareLinie: this.linieNoua.Valoare,
                    AdaosUnitarLinie: this.linieNoua.AdaosUnitar ?? 0,
                    LocDepozitare: this.linieNoua.LocDepozitare,
                    CategorieContabilaId: this.linieNoua.CategorieContabilaId,
                    CantitateFa: this.linieNoua.CantitateFa,
                    CantitatePt1Fa: this.linieNoua.CantitatePt1Fa,
                    CodLotFurnizor: this.linieNoua.CodLotFurnizor,
                    DataExp: this.linieNoua.DataExp,
                    CodLotIntern: this.linieNoua.CodLotIntern,
                    TaxaUnitara: this.linieNoua.TaxaUnitara,
                    ProdusNume: this.linieNoua.Nume,
                });
            } else if (this.document?.Categorie === 'Documente productie') {
                Object.assign(payload, {
                    ProdusId: this.linieNoua.ProdusId,
                    UnitateId: this.linieNoua.UnitateId,
                    UnitateAmbalajId: this.linieNoua.UnitateAmbalajId,
                    Cantitate: this.linieNoua.Cantitate,
                    PretUnitar: this.linieNoua.PretUnitar,
                    ValoareLinie: this.linieNoua.Valoare,
                    AdaosUnitarLinie: this.linieNoua.AdaosUnitar ?? 0,
                    LocDepozitare: this.linieNoua.LocDepozitare,
                    CategorieContabilaId: this.linieNoua.CategorieContabilaId,
                    CantitateFa: this.linieNoua.CantitateFa,
                    CantitatePt1Fa: this.linieNoua.CantitatePt1Fa,
                    CodLotFurnizor: this.linieNoua.CodLotFurnizor,
                    DataExp: this.linieNoua.DataExp,
                    CodLotIntern: this.linieNoua.CodLotIntern,
                    TaxaUnitara: this.linieNoua.TaxaUnitara,
                    ProdusNume: this.linieNoua.Nume,
                });
            }

            try {
                await DOC_Linii.save(this.document.Id, payload);
                notify('Linia a fost adăugată cu succes.', 'success', 2000);

                const comp = this.$refs.liniiComponent as any;
                if (comp?.reloadGrid) {
                    await comp.reloadGrid();
                }
                this.loadLinii();
                this.$emit('refresh-document', this.document.Id);
                this.onCloseAdd();
            } catch (error: any) {
                const msg =
                    error?.response?.data?.error?.message ||
                    error?.message ||
                    'Eroare la salvarea liniei.';
                notify(msg, 'error', 4000);
            }
        },
        getDataSource(cellData: any) {
            // Verificăm dacă structura există înainte de a accesa
            return cellData?.editorOptions?.dataSource;
        },
        async onTiparirePDF() {
            if (this.isPrinting) return;
            this.isPrinting = true;
            try {
                const token = localStorage.getItem('ERA_Jwt') ?? '';
                const isGuid = (s: string | null | undefined): boolean =>
                    !!s && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s);

                // 1. Fetch DOC_Tipuri — report identifiers + template settings per document type
                let tipRaport: any = null;
                if (this.document.TipId) {
                    try {
                        const tipResp = await http.clientDocumenteOdata.get(
                            `DOC_Tipuri(${this.document.TipId})?$select=ClasaRaport,ClasaRaport2,TitluRaport,AreFundal,RaportAntetAreTel,RaportAntetAreFax,RaportAntetAreEmail,RaportAntetAreWww`
                        );
                        tipRaport = tipResp.data;
                    } catch { /* ignore */ }
                }

                // 2. Try DevExpress report from Rapoarte module
                //    Backend lookup order: ERP_ReportsDesigner.ID → ERP_Reports.ID → ERP_Reports.nume
                //    Tries ClasaRaport first, then ClasaRaport2 as alternative layout
                const tryDevExpressReport = async (clasaRaport: string | null | undefined): Promise<boolean> => {
                    if (!clasaRaport) return false;
                    try {
                        const params = new URLSearchParams({ clasaRaport, documentID: this.document.Id });
                        const url = `${AppSetting.API_Url_Rapoarte}report/GetReportByClasaRaport?${params}`;
                        const resp = await fetch(url, { headers: { Authorization: 'Bearer ' + token } });
                        if (resp.ok && resp.headers.get('content-type')?.includes('application/pdf')) {
                            const blob = await resp.blob();
                            const blobUrl = URL.createObjectURL(blob);
                            const win = window.open(blobUrl, '_blank');
                            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
                            if (!win) notify('Permiteți pop-up-uri pentru a vizualiza documentul.', 'warning', 4000);
                            return true;
                        }
                    } catch { /* ignore */ }
                    return false;
                };

                if (await tryDevExpressReport(tipRaport?.ClasaRaport)) return;
                if (await tryDevExpressReport(tipRaport?.ClasaRaport2)) return;

                // 3. HTML fallback — generate printable page in browser using DOC_Tipuri template settings
                const docId = this.document.Id;

                let emitent: any = null;
                if (this.document.StructuraId) {
                    try {
                        const sResp = await http.clientDocumenteOdata.get(
                            `ERP_StructuraCompanie(${this.document.StructuraId})?$select=PartenerId`
                        );
                        const partenerId = sResp.data?.PartenerId;
                        if (partenerId) {
                            const pResp = await http.clientDocumenteOdata.get(
                                `PAR_Parteneri(${partenerId})?$select=Nume,CUI,Numar,Strada,Localitate,Tel,Fax,Banca,Cont`
                            );
                            emitent = pResp.data;
                        }
                    } catch { /* ignore */ }
                }

                let cumparator: any = null;
                if (this.document.PartenerId) {
                    try {
                        const pResp = await http.clientDocumenteOdata.get(
                            `PAR_Parteneri(${this.document.PartenerId})?$select=Nume,CUI,Numar,Strada,Localitate,Banca,Cont`
                        );
                        cumparator = pResp.data;
                    } catch { /* ignore */ }
                }

                const liniiResp = await http.clientDocumenteOdata.get(
                    `DOC_Linii?$filter=DocumentId eq ${docId}&$expand=Produs($select=Cod,Nume),Unitate($select=Simbol)&$orderby=DataCreare asc`
                );
                const linii: any[] = liniiResp.data?.value ?? [];

                const html = this.buildInvoiceHtml(emitent, cumparator, linii, tipRaport);

                const win = window.open('', '_blank');
                if (!win) { notify('Permiteți pop-up-uri pentru a vizualiza documentul.', 'warning', 4000); return; }
                win.document.open();
                win.document.write(html);
                win.document.close();

            } catch (err: any) {
                notify('Eroare la generarea preview: ' + (err?.message ?? 'Eroare'), 'error', 4000);
            } finally {
                this.isPrinting = false;
            }
        },

        buildInvoiceHtml(emitent: any, cumparator: any, linii: any[], tipRaport: any = null): string {
            const fmt = (n: any) => n != null ? Number(n).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00';
            const fmtDate = (d: any) => d ? new Date(d).toLocaleDateString('ro-RO') : '-';
            const esc = (s: any) => (s ?? '').toString()
                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

            // TitluRaport from DOC_Tipuri overrides the generic document type name
            const titlu = esc(tipRaport?.TitluRaport || this.document.Tip || 'Document');
            const numar = esc(this.document.Numar ?? '-');
            const valuta = esc(this.document.Valuta ?? 'RON');

            // RaportAntet* flags from DOC_Tipuri control what contact info to show (null = show)
            const showTel = tipRaport?.RaportAntetAreTel !== false;
            const showFax = tipRaport?.RaportAntetAreFax !== false;

            const partyHtml = (party: any, label: string, isEmitent = false) => {
                if (!party) return `<div class="party"><div class="party-title">${label}</div><div class="party-name">-</div></div>`;
                let rows = `<div class="party-title">${label}</div><div class="party-name">${esc(party.Nume)}</div>`;
                if (party.CUI) rows += `<div class="party-row">CUI: ${esc(party.CUI)}</div>`;
                if (party.Numar) rows += `<div class="party-row">Nr. Reg. Com.: ${esc(party.Numar)}</div>`;
                if (party.Strada) rows += `<div class="party-row">${esc(party.Strada)}</div>`;
                if (party.Localitate) rows += `<div class="party-row">${esc(party.Localitate)}</div>`;
                if (isEmitent && showTel && party.Tel) rows += `<div class="party-row">Tel: ${esc(party.Tel)}</div>`;
                if (isEmitent && showFax && party.Fax) rows += `<div class="party-row">Fax: ${esc(party.Fax)}</div>`;
                if (party.Banca) rows += `<div class="party-row">Banca: ${esc(party.Banca)}</div>`;
                if (party.Cont) rows += `<div class="party-row">Cont: ${esc(party.Cont)}</div>`;
                return `<div class="party">${rows}</div>`;
            };

            let liniiRows = '';
            linii.forEach((l: any, i: number) => {
                liniiRows += `<tr>
                    <td class="nr">${i + 1}</td>
                    <td class="cod">${esc(l.Produs?.Cod ?? '-')}</td>
                    <td>${esc(l.Produs?.Nume ?? l.Nume ?? '-')}</td>
                    <td class="um">${esc(l.Unitate?.Simbol ?? '-')}</td>
                    <td class="num">${fmt(l.Cantitate)}</td>
                    <td class="num">${fmt(l.PretUnitar)}</td>
                    <td class="num">${(l.Tva ?? 0)}%</td>
                    <td class="num">${fmt(l.Valoare)}</td>
                    <td class="num bold">${fmt(l.Total)}</td>
                </tr>`;
            });

            const scadenta = this.document.Scadenta
                ? ` &nbsp;|&nbsp; Scaden&#x21b;&#x103;: <strong>${fmtDate(this.document.Scadenta)}</strong>`
                : '';
            const obs = this.document.Observatii
                ? `<div class="obs">Obs: ${esc(this.document.Observatii)}</div>`
                : '';
            const accize = this.document.Accize && this.document.Accize !== 0
                ? `<div class="totals-row"><span class="totals-label">Accize:</span><span>${fmt(this.document.Accize)} ${valuta}</span></div>`
                : '';
            const cursRand = this.document.Valuta && this.document.Valuta !== 'RON' && this.document.Curs
                ? `<div class="obs">Curs valutar: 1 ${valuta} = ${Number(this.document.Curs).toLocaleString('ro-RO', { minimumFractionDigits: 4, maximumFractionDigits: 4 })} RON</div>`
                : '';

            return `<!DOCTYPE html><html lang="ro"><head><meta charset="utf-8"/>
<title>${titlu} ${numar}</title>
<style>
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:Arial,sans-serif;font-size:9pt;color:#1e293b;background:#fff;padding:16px}
.page{max-width:210mm;margin:0 auto;padding:6mm 10mm}
h1{font-size:18pt;font-weight:700;text-align:center;text-transform:uppercase;letter-spacing:1px;margin-bottom:2mm}
.doc-meta{text-align:center;font-size:9pt;color:#475569;margin-bottom:6mm}
.parties{display:flex;gap:6mm;margin-bottom:5mm}
.party{flex:1;border:1px solid #e5e7eb;border-radius:4px;padding:3mm 4mm;font-size:8.5pt}
.party-title{font-size:7.5pt;font-weight:700;text-transform:uppercase;color:#94a3b8;letter-spacing:.5px;margin-bottom:2mm;border-bottom:1px solid #f1f5f9;padding-bottom:1mm}
.party-name{font-weight:700;font-size:10pt;margin-bottom:1mm}
.party-row{color:#475569;margin-bottom:.5mm}
table{width:100%;border-collapse:collapse;font-size:8pt;margin-bottom:4mm}
thead th{background:#1e293b;color:#fff;padding:2.5mm 2mm;text-align:left;font-weight:600;font-size:7.5pt}
thead th.num{text-align:right}thead th.um{text-align:center}
tbody tr:nth-child(even){background:#f8f9fc}
tbody td{padding:2mm;border-bottom:1px solid #e5e7eb;vertical-align:top}
td.num{text-align:right;white-space:nowrap}
td.nr{text-align:center;width:8mm;color:#64748b}
td.cod{width:22mm;font-family:monospace;font-size:8pt}
td.um{width:10mm;text-align:center}
.bold{font-weight:700}
.totals{display:flex;justify-content:flex-end;margin-bottom:4mm}
.totals-box{border:1px solid #e5e7eb;border-radius:4px;padding:3mm 5mm;min-width:64mm;font-size:9pt}
.totals-row{display:flex;justify-content:space-between;gap:10mm;padding:1.2mm 0;border-bottom:1px solid #f1f5f9}
.totals-row:last-child{border-bottom:none;font-weight:700;font-size:10pt;padding-top:2mm;color:#059669}
.totals-label{color:#475569}
.sign-area{display:flex;gap:8mm;margin-top:8mm;font-size:8pt;color:#475569}
.sign-box{flex:1;text-align:center;border-top:1px solid #94a3b8;padding-top:2mm}
.obs{font-size:8pt;color:#475569;margin-bottom:4mm;padding:2mm 3mm;background:#f8f9fc;border-left:3px solid #e5e7eb;border-radius:2px}
.print-btn{margin-top:14px;text-align:center}
.print-btn button{padding:8px 22px;background:#ff2c21;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:10pt;font-family:Arial,sans-serif}
@media print{.print-btn{display:none}body{padding:0}.page{padding:4mm 6mm}@page{size:A4 portrait;margin:8mm}}
</style></head><body><div class="page">
<h1>${titlu}</h1>
<div class="doc-meta">Nr. <strong>${numar}</strong> &nbsp;|&nbsp; Data: <strong>${fmtDate(this.document.Data)}</strong>${scadenta}</div>
<div class="parties">${partyHtml(emitent, 'Furnizor', true)}${partyHtml(cumparator, 'Cump&#x103;r&#x103;tor')}</div>
${obs}
<table><thead><tr>
<th class="nr">Nr.</th><th class="cod">Cod</th><th>Denumire</th>
<th class="um">UM</th><th class="num">Cantitate</th><th class="num">Pre&#x21a; unitar</th>
<th class="num">TVA %</th><th class="num">Valoare</th><th class="num">Total</th>
</tr></thead><tbody>${liniiRows}</tbody></table>
<div class="totals"><div class="totals-box">
<div class="totals-row"><span class="totals-label">Valoare f&#x103;r&#x103; TVA:</span><span>${fmt(this.document.Valoare)} ${valuta}</span></div>
<div class="totals-row"><span class="totals-label">TVA:</span><span>${fmt(this.document.ValoareTva)} ${valuta}</span></div>
${accize}<div class="totals-row"><span class="totals-label">TOTAL:</span><span>${fmt(this.document.Total)} ${valuta}</span></div>
</div></div>
${cursRand}
<div class="sign-area">
<div class="sign-box">Furnizor<br/><br/><br/></div>
<div class="sign-box">Cump&#x103;r&#x103;tor<br/><br/><br/></div>
<div class="sign-box">Gestionar<br/><br/><br/></div>
</div>
<div class="print-btn"><button onclick="window.print()">Tip&#x103;re&#x219;te / Salveaz&#x103; PDF</button></div>
</div></body></html>`;
        },

        buildAvizPdf(pdf: any, linii: any[], titluRaport: string, cuPreturi: boolean) {
            const pageW = 210, marginL = 14, marginR = 14, contentW = 182;
            const fmt = (n: any) => n != null ? Number(n).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
            const fmtDate = (d: any) => d ? new Date(d).toLocaleDateString('ro-RO') : '';
            let y = 18;

            pdf.setFontSize(16); pdf.setFont('helvetica', 'bold');
            pdf.text(titluRaport.toUpperCase(), pageW / 2, y, { align: 'center' });
            y += 7;
            pdf.setFontSize(9); pdf.setFont('helvetica', 'normal');
            pdf.text(`Nr. ${this.document.Numar ?? '—'}   |   Data: ${fmtDate(this.document.Data)}`, pageW / 2, y, { align: 'center' });
            y += 10;

            pdf.setFillColor(248, 249, 252);
            pdf.rect(marginL, y, contentW, 20, 'F');
            pdf.setFontSize(8); pdf.setFont('helvetica', 'bold');
            pdf.text('DESTINATAR:', marginL + 3, y + 5);
            pdf.setFont('helvetica', 'normal');
            pdf.text(this.document.Partener ?? '—', marginL + 3, y + 10);
            if (this.document.PartenerCUI) pdf.text(`CUI: ${this.document.PartenerCUI}`, marginL + 3, y + 15);
            y += 24;

            const cols = cuPreturi
                ? [
                    { header: 'Nr.', width: 10, align: 'left' },
                    { header: 'Cod', width: 22, align: 'left' },
                    { header: 'Denumire', width: 71, align: 'left' },
                    { header: 'UM', width: 12, align: 'left' },
                    { header: 'Cant.', width: 18, align: 'right' },
                    { header: 'Preț unitar', width: 25, align: 'right' },
                    { header: 'Total', width: 24, align: 'right' },
                  ]
                : [
                    { header: 'Nr.', width: 10, align: 'left' },
                    { header: 'Cod', width: 25, align: 'left' },
                    { header: 'Denumire', width: 100, align: 'left' },
                    { header: 'UM', width: 18, align: 'left' },
                    { header: 'Cant.', width: 29, align: 'right' },
                  ];

            y = this.drawPdfTableHeader(pdf, cols, marginL, y, contentW);
            y = this.drawPdfTableRows(pdf, cols, linii, marginL, y, contentW, (l: any, i: number) =>
                cuPreturi
                    ? [String(i + 1), l.Produs?.Cod ?? '—', (l.Produs?.Nume || l.Nume || '—').substring(0, 42), l.Unitate?.Simbol ?? '—', fmt(l.Cantitate), fmt(l.PretUnitar), fmt(l.Total)]
                    : [String(i + 1), l.Produs?.Cod ?? '—', (l.Produs?.Nume || l.Nume || '—').substring(0, 55), l.Unitate?.Simbol ?? '—', fmt(l.Cantitate)]
            );

            pdf.setDrawColor(200, 200, 200);
            pdf.line(marginL, y, marginL + contentW, y);
            if (cuPreturi && this.document.Total) {
                y += 6;
                const totX = pageW - marginR - 60;
                pdf.setFont('helvetica', 'bold'); pdf.setFontSize(9);
                pdf.text('TOTAL:', totX, y);
                pdf.text(`${fmt(this.document.Total)} ${this.document.Valuta ?? 'RON'}`, pageW - marginR, y, { align: 'right' });
            }
        },

        buildDocumentGenericPdf(pdf: any, linii: any[], titluRaport: string) {
            const pageW = 210, marginL = 14, marginR = 14, contentW = 182;
            const fmt = (n: any) => n != null ? Number(n).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
            const fmtDate = (d: any) => d ? new Date(d).toLocaleDateString('ro-RO') : '';
            let y = 18;

            pdf.setFontSize(16); pdf.setFont('helvetica', 'bold');
            pdf.text(titluRaport.toUpperCase(), pageW / 2, y, { align: 'center' });
            y += 7;
            pdf.setFontSize(9); pdf.setFont('helvetica', 'normal');
            pdf.text(`Nr. ${this.document.Numar ?? '—'}   |   Data: ${fmtDate(this.document.Data)}`, pageW / 2, y, { align: 'center' });
            y += 10;

            if (this.document.Partener) {
                pdf.setFillColor(248, 249, 252);
                pdf.rect(marginL, y, contentW, 14, 'F');
                pdf.setFontSize(8); pdf.setFont('helvetica', 'normal');
                pdf.text(this.document.Partener, marginL + 3, y + 8);
                y += 18;
            }

            const cols = [
                { header: 'Nr.', width: 10, align: 'left' },
                { header: 'Cod', width: 25, align: 'left' },
                { header: 'Denumire', width: 95, align: 'left' },
                { header: 'UM', width: 15, align: 'left' },
                { header: 'Cant.', width: 20, align: 'right' },
                { header: 'Total', width: 17, align: 'right' },
            ];
            y = this.drawPdfTableHeader(pdf, cols, marginL, y, contentW);
            y = this.drawPdfTableRows(pdf, cols, linii, marginL, y, contentW, (l: any, i: number) => [
                String(i + 1), l.Produs?.Cod ?? '—',
                (l.Produs?.Nume || l.Nume || '—').substring(0, 52),
                l.Unitate?.Simbol ?? '—', fmt(l.Cantitate), fmt(l.Total),
            ]);

            if (this.document.Total) {
                y += 6;
                const totX = pageW - marginR - 50;
                pdf.setFont('helvetica', 'bold'); pdf.setFontSize(9);
                pdf.text('TOTAL:', totX, y);
                pdf.text(`${fmt(this.document.Total)} ${this.document.Valuta ?? 'RON'}`, pageW - marginR, y, { align: 'right' });
            }
        },

        drawPdfTableHeader(pdf: any, cols: any[], marginL: number, y: number, contentW: number): number {
            pdf.setFillColor(40, 40, 40);
            pdf.rect(marginL, y, contentW, 7, 'F');
            pdf.setFontSize(7.5); pdf.setFont('helvetica', 'bold');
            pdf.setTextColor(255, 255, 255);
            let x = marginL + 2;
            for (const col of cols) {
                col.align === 'right'
                    ? pdf.text(col.header, x + col.width - 2, y + 4.8, { align: 'right' })
                    : pdf.text(col.header, x, y + 4.8);
                x += col.width;
            }
            pdf.setTextColor(0, 0, 0);
            return y + 7;
        },

        drawPdfTableRows(pdf: any, cols: any[], linii: any[], marginL: number, y: number, contentW: number, getVals: (l: any, i: number) => string[]): number {
            pdf.setFont('helvetica', 'normal'); pdf.setFontSize(7.5);
            linii.forEach((linie, idx) => {
                if (y > 270) { pdf.addPage(); y = 15; }
                if (idx % 2 === 0) {
                    pdf.setFillColor(248, 249, 252);
                    pdf.rect(marginL, y, contentW, 6, 'F');
                }
                const vals = getVals(linie, idx);
                let x = marginL + 2;
                for (let i = 0; i < cols.length; i++) {
                    cols[i].align === 'right'
                        ? pdf.text(vals[i] ?? '', x + cols[i].width - 2, y + 4, { align: 'right' })
                        : pdf.text(vals[i] ?? '', x, y + 4);
                    x += cols[i].width;
                }
                y += 6;
            });
            return y;
        },
        async shareClicked() {
            const textToCopy = `${window.location.origin}` + `/documente?id=${this.document.Id}`

            if (!textToCopy) {
                notify('Nu există ID de document de copiat.', 'warning', 5000);
                return;
            }

            try {
                await navigator.clipboard.writeText(textToCopy);
                notify('Adresa URL a fost copiată', 'success', 5000);
            } catch (err) {
                console.error('Eroare la copiere:', err);
                notify('Eroare la copiere. Copiere manuală necesară.', 'error', 5000);
            }
        },
        produsDisplayExpr(item: any) {
            if (!item) return "";
            return `${item.Cod || ''} - ${item.Nume || ''} - ${item.CodIntern || ''}`;
        },
        departamentDisplayExpr(item: any) {
            if (!item) return '';
            return item.Descr ? `${item.Descr} - ${item.Nume || ''}` : (item.Nume || '');
        },
        buildDepartamentTree(flat: any[], parentId: string | null = null): any[] {
            const pid = parentId != null ? String(parentId).toLowerCase() : null;
            return flat
                .filter(i => {
                    const p = i.ParentId != null ? String(i.ParentId).toLowerCase() : null;
                    return p === pid;
                })
                .map(i => ({ ...i, expanded: true, items: this.buildDepartamentTree(flat, i.Id) }));
        },
        onPersonalDepartamentSelect(e: any) {
            this.linieNoua.StructIdEditabil = e.itemData?.Id ?? null;
            (this.$refs.personalDepartamentBox as any)?.instance?.close();
        },
        goBack() {
            this.$router.push('/documente')
            this.$emit('back')
        },
        updateReadOnly() {
            if (this.isReadonly === true) {
                this.isReadonly = false
                this.isDisabled = false
            }
            else {
                this.isReadonly = true
                this.isDisabled = true
            }
        },
        // onValueChangedCategorie(e: any) {
        //     let _filter;
        //     if (e.value != null) {
        //         _filter = ["CategorieId", "=", e.value];
        //     } else {
        //         _filter = null;
        //     }
        //     this.dsTipDocumente.filter(_filter);
        //     this.dsTipDocumente.load();
        // },
        onTipDocumentSelected(e: any) {
            this.document.TipId = e.value
            this.dsTipDocumente.store().byKey(this.document.TipId).then((tip) => {
                this.dsCategorieDocumente.store().byKey(tip.CategorieId).then((categorie) => {
                    this.categorieDocument = categorie
                })
            })
        },
        onPartenerSelected(e: any) {
            this.partenerNou.ID = e.selectedItem.ID
            this.partenerNou.Nume = e.selectedItem.Nume
            this.partenerNou.CUI = e.selectedItem.CUI
            this.partenerNou.Cod = e.selectedItem.Cod

            this.dsGrupePartener.filter("Id", "=", e.selectedItem.GrupID)
            this.dsGrupePartener.load().then((data: any[]) => {
                if (data && data.length > 0)
                    this.partenerNou.GrupPartener = data[0].Nume
            })
        },
        onPartenerCUISelected(e: any) {
            this.partenerNou.ID = e.selectedItem.ID
            this.partenerNou.Nume = e.selectedItem.Nume
            this.partenerNou.CUI = e.selectedItem.CUI
            this.partenerNou.Cod = e.selectedItem.Cod

            this.dsGrupePartener.filter("Id", "=", e.selectedItem.GrupID)
            this.dsGrupePartener.load().then((data: any[]) => {
                if (data && data.length > 0)
                    this.partenerNou.GrupPartener = data[0].Nume
            })
        },
        async onEditLinie() {
            // Deprecated: Grid built-in editing is used instead
        },
        EditDocumentClicked() {
            this.isReadonly = false;
        },
        async SaveDocumentClicked() {
            try {
                if (!this.document?.Id) {
                    notify("Lipsește Id-ul documentului.", "error", 3000);
                    return;
                }

                // Payload curat: DOAR proprietăți care există în DOC_Documente (EF)
                const payload = {
                    TipId: this.document.TipId ?? null,
                    Numar: this.document.Numar ?? null,
                    Data: this.document.Data ?? null,
                    DataDoc: this.document.DataDoc ?? null,
                    Scadenta: this.document.Scadenta ?? null,

                    GestiuneIntrareId: this.document.GestiuneIntrareId ?? null,
                    GestiuneIesireId: this.document.GestiuneIesireId ?? null,

                    Document: this.document.Document ?? null,
                    ValutaId: this.document.ValutaId ?? null,
                    Curs: this.document.Curs ?? this.document.PretCurs ?? null,
                    PretValutaId: this.document.PretValutaId ?? null,
                    PretCurs: this.document.PretCurs ?? this.document.Curs ?? null,

                    Tva: this.document.Tva ?? null,
                    Valoare: this.document.Valoare ?? null,
                    ValoareTva: this.document.ValoareTva ?? null,
                    Accize: this.document.Accize ?? null,
                    Total: this.document.Total ?? null,

                    Explicatie: this.document.Explicatie ?? null,
                    Observatii: this.document.Observatii ?? null,

                    PartenerId: this.document.PartenerId ?? null,
                    ContractNumar: this.document.ContractNumar ?? null,
                    ContractId: this.document.ContractId ?? null,

                    Adaos: this.document.Adaos ?? null,
                    AdaosValoare: this.document.AdaosValoare ?? null,

                    AreCaf: this.document.AreCaf ?? null,
                    ProcentCaf: this.document.ProcentCaf ?? null,
                    ValoareCaf: this.document.ValoareCaf ?? null,

                    AgentId: this.document.AgentId ?? null,
                    LocDepozitare: this.document.LocDepozitare ?? null,

                    StornatRetur: this.document.StornatRetur ?? null,
                    Autofacturat: this.document.Autofacturat ?? null,
                    EmisTert: this.document.EmisTert ?? null,
                    TvaLaIncasare: this.document.TvaLaIncasare ?? null,

                    ZonaId: this.document.ZonaId ?? null,

                    // dacă ai în UI:
                    ComandaId: this.document.ComandaId ?? null,
                    ProiectId: this.document.ProiectId ?? null,
                    StructIdEditabil: this.document.StructIdEditabil ?? null,
                    StructuraId: this.document.StructuraId ?? null,
                    NotaId: this.document.NotaId ?? null
                };

                console.log("PATCH payload (clean):", payload);

                await DOC_Documente.update(this.document.Id, payload);

                notify("Documentul a fost salvat cu succes.", "success", 2000);
                this.isReadonly = true;
            } catch (error) {
                console.error("Eroare la salvarea documentului:", error);
                const msg =
                    error?.response?.data?.error?.message ||
                    error?.response?.data?.message ||
                    error?.response?.data?.title ||
                    error?.message ||
                    "Eroare la salvare.";
                notify(msg, "error", 3000);
            }
        },
        onProdusIdCellValueChanged(newData: any, value: any) {
            newData.ProdusId = value;
            if (value) {
                return this.dsProdus.store().byKey(value).then((produs: any) => {
                    if (produs) {
                        newData.UnitateId = produs.UnitateId;
                        newData.CategorieContabilaId = produs.CategorieContabilaId;
                    }
                });
            }
        },
        headerEditClicked() {
            this.isReadonly = false;
        },
        headerSaveClicked() {
            this.submitForm();
            this.isReadonly = true;
        },
        closeClicked() {
            this.goBack();
        },
        onValueChangedProdusEdit(e: any) {
            // Deprecated
        },
        loadLinii() {
            this.dsLinii = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + `DOC_Linii`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    fieldTypes: {
                        DocumentId: "Guid"
                    },
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                        e.params.$expand = "Categorie($select=Cod,Nume),Produs($select=Cod,Nume),Unitate($select=Simbol,Nume,Cod)"
                    },
                },
            });
            this.dsLinii.filter(["DocumentId", "=", this.document.Id]);
            this.dsLinii.load().then((loadedData: any[]) => {
                console.log('loadedData length:', loadedData?.length);
                console.log('document.Id:', this.document.Id);
                this.areLinii = loadedData && loadedData.length > 0
                console.log(this.areLinii)
            })
        },
        submitForm() {
            // Logic to save the whole document form
        },
        formatDate(date: any) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleDateString('ro-RO');
        },
        buildLiniePayload(row: any) {
            return {
                ProdusId: row?.ProdusId ?? null,
                UnitateId: row?.UnitateId ?? null,
                Cantitate: row?.Cantitate ?? null,
                TvaLinie: row?.Tva ?? null,
                PretUnitar: row?.PretUnitar ?? row?.Pret ?? null,
                CategorieContabilaId: row?.CategorieContabilaId ?? null
            };
        },
        onSavingLinie(e: any) {
            const change = e.changes?.[0];

            if (!change || change.type !== 'update') {
                return;
            }

            e.cancel = true;

            e.promise = (async () => {
                try {
                    const mergedRow = {
                        ...(this.editingOriginalRow ?? {}),
                        ...(change.data ?? {})
                    };

                    const payload = this.buildLiniePayload(mergedRow);

                    await DOC_Linii.update(change.key, payload);

                    await this.dsLinii.reload();

                    if (this.$refs.dataGrid) {
                        (this.$refs.dataGrid as any).instance.cancelEditData();
                        (this.$refs.dataGrid as any).instance.refresh();
                    }

                    this.areLinii = true;
                    this.$emit('refresh-document', this.document.Id);

                    notify("Linia a fost actualizată cu succes.", "success", 2000);
                } catch (error: any) {
                    console.error("Eroare la actualizarea liniei:", error);

                    const msg =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.message ||
                        error?.response?.data?.title ||
                        error?.message ||
                        "A apărut o eroare la actualizarea liniei.";

                    notify(msg, "error", 4000);
                    throw error;
                } finally {
                    this.editingOriginalRow = null
                }
            })();
        },
    },
    mounted() {
        console.log("AICI!!!!!!!!!!!!!")
        console.log(this.document)
        if (this.document !== null) {
            this.loadLinii()
        }
        this.dsCategorieDocumente = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'DOC_Categorii',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsTipDocumente = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + `DOC_Tipuri`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            }
        });
        this.dsTipDocumente.store().byKey(this.document.TipId).then((tip) => {
            this.dsCategorieDocumente.store().byKey(tip.CategorieId).then((categorie) => {
                this.categorieDocument = categorie
            })
        })
        this.dsAgent = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'COM_Agenti',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                    };
                }
            },
        });
        this.dsZone = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'ERP_Zone',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsNumereContracte = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ComercialOdata + 'COM_Contracte',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
            select: [
                'Id',
                'NumarContract'
            ]
        });
        this.dsPartener = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'PAR_Parteneri',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    }
                }
            }
        });
        this.dsGrupePartener = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'PAR_Grupuri',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsProiecte = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + `DOC_Proiecte`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsStructuriIdEditabile = new DataSource({
            paginate: false,
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'ERP_StructuraCompanie',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            }
        });
        this.dsStructuriIdEditabile.load().then((items: any[]) => {
            this.structuriIdEditabileItems = items;
            this.structuriIdEditabileTree = this.buildDepartamentTree(items);
        });
        this.dsGestiune = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + `GES_Gestiuni`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsValute = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ComercialOdata + `ERP_Valute`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsComenzi = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + `PRO_Comenzi`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsProdus = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'PRO_Produse',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    }
                }
            },
            select: [
                'Id',
                'Cod',
                'Nume',
                'UnitateId',
                'CategorieContabilaId',
                'CodIntern',
                'Descriere'
            ],
        });
        this.dsUnitate = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ComercialOdata + 'PRO_Unitati',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    }
                }
            },
        });
        this.dsCategorieContabila = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'CON_CategoriiContabile',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsConturi = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'CON_Conturi',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsCustomList = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'DOC_CustomList',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.setDeleteConfirmationMessage();
        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });

        locale('ro');
    }
});
</script>
<style>
.add-form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 16px;
}

.fab-edit-document {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff2c21, #ff6a4a);
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 16px rgba(255, 44, 33, 0.45);
    z-index: 500;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.fab-edit-document:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 20px rgba(255, 44, 33, 0.55);
}

.fab-edit-document .dx-icon-edit {
    font-size: 22px;
}

.add-form-field {
    display: flex;
    flex-direction: column;
}

.add-form-field--full {
    grid-column: 1 / -1;
}

.form-footer-linie {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
}

.footer-fixed-linie {
    position: sticky;
    bottom: 0;
    padding: 10px 16px;
    display: flex;
    /* Forțează conținutul spre dreapta */
    justify-content: flex-end;
    gap: 12px;
    z-index: 10;
    background-color: white;
    /* Recomandat pentru sticky footer */
}

.footer-modern-linie {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 24px;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
}

.footer-right-linie {
    display: flex;
    gap: 12px;
    /* Spațiu între cele două butoane */
}

.popup-header-linie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
}

.popup-linii .dx-popup-content {
    padding: 0 !important;
}

.popup-header-main-linie {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon-linie {
    font-size: 20px;
}

.popup-header-texts-linie {
    display: flex;
    flex-direction: column;
}

.popup-header-title-linie {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle-linie {
    font-size: 12px;
    opacity: 0.85;
}

.popup-header-meta-linie {
    display: flex;
    align-items: center;
}

.status-chip-linie {
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid rgba(255, 255, 255, 0.7);
}

.status-chip--draft-linie {
    background-color: rgba(255, 255, 255, 0.18);
}

.lini-view-container {
    padding: 12px 20px;
    background: #fdfdfd;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    position: relative;
    overflow: hidden;
}

.grid-section {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.grid-section > div {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

/* ── Document Header Card ── */
.doc-header-card {
    flex-shrink: 0;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin: 0 0 8px;
}

.doc-header-top {
    padding: 7px 16px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.doc-header-main {
    display: flex;
    align-items: center;
    gap: 8px;
}

.doc-hdr-icon {
    font-size: 16px;
    color: #fff;
}

.doc-hdr-numar {
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.3px;
}

.doc-hdr-categorie-badge {
    font-size: 11px;
    font-weight: 600;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    padding: 2px 10px;
    border-radius: 12px;
    letter-spacing: 0.3px;
}

.doc-header-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.doc-header-actions .dx-button {
    color: #fff !important;
    min-height: unset !important;
    height: 28px !important;
    width: 28px !important;
}

.doc-meta-strip {
    display: flex;
    align-items: center;
    padding: 10px 18px;
    gap: 0;
    flex-wrap: nowrap;
    border-top: 1px solid #f1f5f9;
    overflow: hidden;
}

.doc-meta-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 16px 0 0;
}

.doc-meta-divider {
    width: 1px;
    height: 28px;
    background: #e5e7eb;
    margin-right: 16px;
    flex-shrink: 0;
}

.doc-meta-icon {
    font-size: 14px;
    color: #64748b;
}

.doc-meta-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.doc-meta-label {
    font-size: 11px;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1;
}

.doc-meta-value {
    font-size: 14px;
    font-weight: 500;
    color: #334155;
    line-height: 1.3;
}

.doc-meta-item--partener {
    flex-shrink: 1;
    min-width: 0;
    max-width: 220px;
}

.doc-meta-value--partener {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 200px;
}

.doc-meta-spacer {
    flex: 1;
}

.doc-totals-box {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 9px 16px;
    background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
    border: 1px solid #bbf7d0;
    border-radius: 10px;
    min-width: 195px;
    box-shadow: 0 1px 3px rgba(5, 150, 105, 0.08);
}

.doc-totals-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 16px;
}

.doc-totals-label {
    font-size: 11px;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
    line-height: 1;
}

.doc-totals-label--main {
    color: #065f46;
}

.doc-totals-value-secondary {
    font-size: 12px;
    font-weight: 500;
    color: #475569;
    white-space: nowrap;
}

.doc-totals-value-main {
    font-size: 15px;
    font-weight: 700;
    color: #059669;
    white-space: nowrap;
}

.doc-totals-separator {
    height: 1px;
    background: #d1fae5;
    margin: 2px 0;
}

/* Grid & Empty State (Condensed) */
:deep(.dx-datagrid) {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #edf2f7;
}


.no-lines-empty-state,
.null-document-state {
    text-align: center;
    padding: 40px;
    background: white;
    border-radius: 12px;
    border: 1px dashed #e2e8f0;
    color: #718096;
    margin-top: 12px;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


.dx-form .dx-form-group:has(.dx-form-group-caption) {
    border: 2px solid #ff6600 !important;
    border-radius: 8px !important;
    padding: 20px !important;
    margin-bottom: 25px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    min-height: 320px;
    margin-left: 30px !important;
}

.dx-field-item {
    padding-top: 6px !important;
    padding-bottom: 0px !important;
    padding-left: 5px !important;
    padding-right: 0px !important;
    margin: 0px !important;
}

.dx-form-group-caption {
    color: #ff6600;
    font-weight: bold;
}

.buttons {
    margin-top: 40px;
}


.cantitate-numberbox {
    margin-left: 130px;
    margin-top: 23px;
}
</style>
